exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".nodata {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  text-align: center;\n}\n.createFormSuggestionBox .ant-select-selection-selected-value .anticon {\n  line-height: 2.6 !important;\n}\n", ""]);

// exports
